import { bool, number, array, string, func } from "prop-types"
import TableColumnIcon from "components/admin/payments_sort/TableColumnIcon"
import getSymbolFromCurrency from "currency-symbol-map"
import accounting from "accounting"
import { Table } from "components/ui"
import { pluralize } from "utils/helpers"
import { formatDateTimeShort } from "utils/dates"
import pcoURL from "@planningcenter/url"
import axios from "axios"
import { useToast } from "components/ui/Toast"

const TransactionsTable = ({
  isFetching = false,
  transactions = [],
  exportParams = "",
  totalCount = 0,
  totalPages = 0,
  page,
  onPaginationClick
}) => {
  const { addToast } = useToast()

  const columns = [
    {
      cell: "",
      label: "Payment type icon",
      hideHeaderLabel: true,
      render: TableColumnIcon,
      renderProps: (row, _col) => ({
        className: `transaction-type transaction-type--${row.type.toLowerCase()}`
      })
    },
    { cell: "payerName", label: "Payee" },
    { cell: "eventName", label: "For" },
    { cell: "amountString", label: "Amount" },
    { cell: "stripeFeeString", label: "Stripe Fee" },
    { cell: "paymentDescription", label: "Method" },
    { cell: "createdAt", label: "Date" }
  ]

  const rows = transactions.map(({ id, attributes }) => {
    const {
      event_currency,
      instrument,
      type,
      cc_card_type,
      cc_last_four,
      check_number,
      scholarship,
      amount_cents,
      stripe_fee_cents,
      created_at,
      payer_name,
      event_name
    } = attributes

    let paymentDescription = instrument

    if (instrument === "Credit Card" || instrument === "ACH") {
      paymentDescription = cc_card_type ? `${cc_card_type} ...${cc_last_four}` : instrument
    } else if (instrument === "Check" && check_number) {
      paymentDescription = `Check Number ${check_number}`
    } else if (instrument === "Scholarship") {
      paymentDescription = `Credit from ${scholarship}`
    }

    if (type === "Refund") {
      paymentDescription = `${paymentDescription} (Refund)`
    }

    const currencySymbol = getSymbolFromCurrency(event_currency)

    return {
      key: `${type}-${id}`,
      id,
      type,
      payerName: payer_name,
      eventName: event_name,
      paymentDescription,
      amountString: amount_cents ? accounting.formatMoney(amount_cents / 100, currencySymbol) : "",
      stripeFeeString: stripe_fee_cents ? (
        accounting.formatMoney(stripe_fee_cents / 100, currencySymbol)
      ) : instrument === "ACH" ? (
        <span
          className={"p-2p"}
          style={{ backgroundColor: "var(--color--coral)", color: "var(--color--brand-91)" }}
        >
          PENDING
        </span>
      ) : (
        ""
      ),
      createdAt: formatDateTimeShort(created_at),
      instrument
    }
  })

  const handleExportCSV = () => {
    axios.post(
      `${`${pcoURL(window.railsEnv)("registrations")}/payments/csv?${exportParams}`}`,
      {},
      {
        withCredentials: true,
        headers: {
          "X-CSRF-Token": $.rails.csrfToken()
        }
      }
    )

    addToast("You will receive an email when your export is ready")
  }

  const handleRowClick = (row, _col) =>
    App.Modal.createAndShowUrlModal(`${row.type.toLowerCase()}s/${row.id}`)

  const pagination = {
    totalPages,
    currentPage: page,
    nextPage: page === totalPages ? null : page + 1,
    prevPage: page === 0 ? null : page - 1
  }

  return (
    <Table
      isLoading={isFetching}
      columns={columns}
      rows={rows}
      onRowClick={handleRowClick}
      heading={{
        headerText: pluralize("transaction", "transactions", totalCount)
      }}
      headingChildren={
        <button className="quiet-btn btn2" onClick={handleExportCSV}>
          Export CSV
        </button>
      }
      emptyTableImageUrl="/static/blank-states/registrations-profile-payments.svg"
      emptyTableMessage="There are no transactions matching your current filters."
      pagination={pagination}
      onPaginateClick={onPaginationClick}
    />
  )
}

TransactionsTable.propTypes = {
  isFetching: bool,
  transactions: array,
  exportParams: string,
  totalCount: number,
  totalPages: number,
  page: number,
  onPaginationClick: func
}

export default TransactionsTable
